export default {
  friendsUpdates: {},
  selectedfriendsUpdates: {},
};
